var _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.46436,
    y: 11.5537,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 2.46436 11.5537)",
    fill: "#00A253"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9736,
    y: 15.46,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 13.9736 15.46)",
    fill: "#00A253"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9175,
    y: 8.80078,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 14.9175 8.80078)",
    fill: "#00A253"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2803,
    y: 2.56055,
    width: 9.86223,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 16.2803 2.56055)",
    fill: "#00A253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLt);
export default __webpack_public_path__ + "static/media/logo-lt.8270fd544d11cd75b47c6c5095518597.svg";
export { ForwardRef as ReactComponent };